jQuery('html').removeClass('no-js').addClass('js yes-js js_active');